import React from 'react';
import {Typography} from '@mui/material';

/**
 * Default fallback card component for unknown task types
 */
export default function DefaultTaskCard({task}) {
    return (
        <Typography
            component="pre"
            sx={{
                fontFamily: 'monospace',
                fontSize: '0.875rem',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                margin: 0,
            }}
        >
            {JSON.stringify(task, null, 2)}
        </Typography>
    );
}

